module.exports = __webpack_public_path__ + "img/zhifu.1499dd40.jpg";